import React from "react";

const Footer = () => {
  return (
    <div className="page-footer text-center footer w-100" id="footer-styling">
      <footer className="">
        <div className="">
          <small className="footerSpan">
            &copy; Copyright - Movie Browsing 2021
          </small>
        </div>
      </footer>
    </div>
  );
};

export default Footer;